import * as React from "react";
import classnames from "classnames";
import { PriceWithAffix, Price } from "@grandvisionhq/lib-visuals";
import { isDefined } from "@grandvisionhq/utils";
/* empty css              */
const PriceTag = ({
  className,
  originalPrice,
  discountedPrice,
  pricePrefix,
  size = "small"
}) => {
  if (isDefined(originalPrice) && isDefined(discountedPrice) && originalPrice !== discountedPrice) {
    return /* @__PURE__ */ React.createElement("div", { className: classnames("rxc-price-tag", className), "data-t": "price-tag" }, /* @__PURE__ */ React.createElement(
      PriceWithAffix,
      {
        className: "rxc-price-tag__with-affix",
        pricePrefix,
        value: discountedPrice,
        isCentAmount: true,
        type: "new",
        "data-t": "price-discounted",
        size
      }
    ), /* @__PURE__ */ React.createElement(
      Price,
      {
        value: originalPrice,
        isCentAmount: true,
        type: "old",
        variant: "strikethrough",
        "data-t": "price-original",
        size
      }
    ));
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames("rxc-price-tag", className) }, /* @__PURE__ */ React.createElement(
    PriceWithAffix,
    {
      className: "rxc-price-tag__with-affix",
      pricePrefix,
      value: originalPrice,
      isCentAmount: true,
      type: "full",
      "data-t": "price-original",
      size
    }
  ));
};
export {
  PriceTag
};
//# sourceMappingURL=PriceTag.js.map
